export const toFixed = (number: number | string, zeros: number) => {
  let result = number.toString()
  
  while (result.length < zeros) {
    result = '0' + result
  }

  return result
}

export const minMax = (value?: number, boundaries?: [ number, number ]) => {
  return Math.max(Math.min(value ?? 0, boundaries?.[1] ?? 0), boundaries?.[0] ?? 99999999)
}

export const round5 = (value: number, offset: number) => {
  return Math.round((value + offset) / 5) * 5;
}

export const versionToNumber = (version: string) => {
  const vc = version.split('.')
  return parseInt(`${toFixed(vc[0], 2)}${toFixed(vc[1], 2)}${toFixed(vc[2], 2)}`)
}

export const round = (number: number | string, decimals: number, isRound = true) => {
  const floatNumber = parseFloat(number.toString())
  return isRound ? floatNumber.toFixed(decimals) : Math.round(floatNumber * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const toMinFloat = (number: number | string, digits: number) => {
  const floatNumber = parseFloat(number.toString())
  return floatNumber.toFixed(digits)
}

export const toMinDigits = (number: number | string, digits = 2) => {
  let result = Number(number).toString()
  while (result.length < digits) result = `0${number}`

  return result
}

export const toReadable = (number?: number | string) => {
  if (!number) return 0
  
  const parts = number.toString().split('.')

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return parts.join('.')
}

export const toK = (number: number | string) => {
  const n = Number(number)

  if (n < 1000) return n.toString()
  if (n < 1_000_000) return (n / 1000).toFixed(1).replace('.', ',') + 'k'

  return (n / 1_000_000).toFixed(1).replace('.', ',') + 'M'
}

export const project = (value: number, from: [number, number], to: [number, number], isConstrain = false) => {
  const projection = (value - from[0]) / (from[1] - from[0]) * (to[1] - to[0]) + to[0]

  return isConstrain ? (
    Math.max(Math.min(projection, to[0] > to[1] ? to[0] : to[1]), to[0] > to[1] ? to[1] : to[0])
  ) : projection
}

export const timer = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  const paddedSeconds = remainingSeconds.toString().padStart(2, '0')

  return `${minutes}:${paddedSeconds}`
}

